import styled from 'styled-components'

import { ButtonBase } from './ButtonBase'

/**
 * Mirroring HubSpot's chat bubble so ours can sit beside it as a floating action button
 * color: rgb(255, 102, 48) instead of theme.colors.primary[50] to match the color of the chat bubble
 * box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) instead of theme.shadows[80] to match the box-shadow of the chat bubble
 */
export const FLOATING_ACTION_BUTTON = {
  size: 60,
  hoverScale: 1.1,
}

export const FloatingActionButton = styled(ButtonBase)`
  width: ${FLOATING_ACTION_BUTTON.size}px;
  height: ${FLOATING_ACTION_BUTTON.size}px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  justify-content: center;
  background-color: rgb(255, 102, 48);
  color: ${({ theme }) => theme.colors.gray[0]};
  box-shadow:
    rgba(0, 0, 0, 0.1) 0 4px 6px -1px,
    rgba(0, 0, 0, 0.1) 0 2px 4px -1px;
  transition:
    transform 150ms ease-out,
    background-color 250ms ease,
    box-shadow 250ms ease;

  &:hover:not(:disabled):not([aria-disabled='true']) {
    transform: scale(${FLOATING_ACTION_BUTTON.hoverScale});
    box-shadow:
      rgba(0, 0, 0, 0.1) 0px 2px 6px,
      rgba(0, 0, 0, 0.2) 0px 4px 16px;
  }

  &:active:not(:disabled):not([aria-disabled='true']) {
    transform: scale(1);
  }

  &:disabled,
  &[aria-disabled='true'] {
    background-color: ${({ theme }) => theme.colors.gray[30]};
    color: ${({ theme }) => theme.colors.gray[40]};
    box-shadow: none;
    cursor: default;
  }

  /* the zoom is decoration; a reduced-motion visitor still gets the colour change */
  @media (prefers-reduced-motion: reduce) {
    transition: background-color 250ms ease;

    &:hover:not(:disabled):not([aria-disabled='true']) {
      transform: none;
    }
  }
`
